import { render } from "./MyPayslips.vue?vue&type=template&id=c343e076&scoped=true&ts=true"
import script from "./MyPayslips.vue?vue&type=script&lang=ts"
export * from "./MyPayslips.vue?vue&type=script&lang=ts"

import "./MyPayslips.vue?vue&type=style&index=0&id=c343e076&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c343e076"]])

export default __exports__